import { filterStoreRepo } from 'components/Filters/FilterStore'
import { FilterGroup } from 'components/Filters/components/FilterModal'
import { DateRangeFilter } from 'components/Filters/fields/DateRangeFilter'
import {
  SelectFilter,
  SelectFilterOption,
} from 'components/Filters/fields/SelectFilter'
import { SingleSelectFilter } from 'components/Filters/fields/SingleSelectFilter'
import { FilterIdentifier } from 'models/saved_view'
import useApiService from 'services/api'
import { useUserOptions } from 'services/users'
import { useMemo } from 'react'
import { ALL_COUNTRIES } from 'utils/countries'

interface MobileNotesFiltersetProps {
  filterIdentifier: FilterIdentifier
  showDoorFilters?: boolean
  contactCompanyId?: number
}

export function MobileNotesFilterset({
  filterIdentifier,
  showDoorFilters = false,
  contactCompanyId,
}: MobileNotesFiltersetProps) {
  const api = useApiService()
  const { data: rawUserOptions } = useUserOptions({
    onlyActive: true,
    withNoneOption: true,
  })

  // Get the city options for door proxies associated with this contact company
  const { data: cityOptions } =
    contactCompanyId && showDoorFilters
      ? api.useGetDoorProxyCities({ contactCompanyId })
      : { data: [] }

  // Get the state options for door proxies associated with this contact company
  const { data: stateOptions } =
    contactCompanyId && showDoorFilters
      ? api.useGetDoorProxyStates({ contactCompanyId })
      : { data: [] }

  // Get product tags when showing door filters
  const { data: rawProductTagsOptions } = showDoorFilters
    ? api.useGetTagsOptions(false)
    : { data: undefined }

  const userOptions: SelectFilterOption[] | undefined = useMemo(() => {
    return rawUserOptions?.map((option) => ({
      ...option,
      value: String(option.value),
    }))
  }, [rawUserOptions])

  const productTagsOptions: SelectFilterOption[] | undefined = useMemo(() => {
    return rawProductTagsOptions?.map((option) => ({
      ...option,
      value: String(option.value),
    }))
  }, [rawProductTagsOptions])

  const notesFilterStore = filterStoreRepo.getStore(filterIdentifier)

  return (
    <>
      <FilterGroup title="Date Filters">
        <DateRangeFilter
          title="Date Created"
          filterKey="created"
          filterStore={notesFilterStore}
        />
        <DateRangeFilter
          title="Date Modified"
          filterKey="modified"
          filterStore={notesFilterStore}
        />
      </FilterGroup>
      <FilterGroup title="Note Attributes">
        <SelectFilter
          title="Created By"
          filterKey="user"
          options={userOptions || []}
          filterStore={notesFilterStore}
        />
        <SingleSelectFilter
          title="Has Attachment"
          filterKey="has_attachment"
          options={[
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' },
          ]}
          filterStore={notesFilterStore}
          hideSearch
        />
      </FilterGroup>
      {showDoorFilters && (
        <FilterGroup title="Door Filters">
          <SelectFilter
            title="Country"
            filterKey="door_country"
            options={ALL_COUNTRIES}
            filterStore={notesFilterStore}
          />
          <SelectFilter
            title="City"
            filterKey="door_city"
            options={cityOptions || []}
            filterStore={notesFilterStore}
          />
          <SelectFilter
            title="State"
            filterKey="door_state"
            options={stateOptions || []}
            filterStore={notesFilterStore}
          />
          <SelectFilter
            title="Door Tags"
            filterKey="door_tags"
            options={productTagsOptions || []}
            filterStore={notesFilterStore}
          />
        </FilterGroup>
      )}
    </>
  )
}
